/* eslint-disable react-hooks/exhaustive-deps */
import { useLiveQuery } from "dexie-react-hooks";
import { set } from "idb-keyval";
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";

const useProdutoFilial = ({ filial, produtoId }) => {
  const [produtoFilial, setProdutoFilial] = useState([]);
  const [produtosDisponiveis, setProdutosDisponiveis] = useState([]);

  const [produtosFiliais, setProdutosFiliais] = useState([]);

  useEffect(() => {
    const fetchProdutosFiliais = async () => {
      const produtosFiliaisTemp = [];
      await db.produtosFiliais.each(item => produtosFiliaisTemp.push(item));
      setProdutosFiliais(produtosFiliaisTemp);
    };

    fetchProdutosFiliais();
  }, []);


const produtosFiliaisDisponiveis = useMemo(() => {
  const dictProdutos = {};

if (produtosFiliais?.length) {
  for (const e of produtosFiliais) {
    const key = `key-${e.filialId}`;
    if (!dictProdutos[key]) dictProdutos[key] = [];
    dictProdutos[key].push(e.produtoId);
  }

  if (filial && dictProdutos[`key-${filial}`]) {
    setProdutosDisponiveis(dictProdutos[`key-${filial}`]);
  }
}


  return dictProdutos;
}, [produtoFilial, produtosFiliais]);


  const produtoNaFilial = useLiveQuery(() => {
    if (produtoId && filial) {
      return db.produtosFiliais.filter(e => e.produtoId == produtoId && e.filialId == filial).first();
    }
  }, [produtoId, filial]);

  return {
    produtosFiliais,
    produtoNaFilial,
    produtosFiliaisDisponiveis,
    setProdutoFilial,
    produtosDisponiveis
  };
}

export default useProdutoFilial;